module.exports = __webpack_public_path__ + "img/interior2.dc8fd197.jpg";